import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareArrowUpRight } from "@fortawesome/free-solid-svg-icons";
import { RootState } from "config/store";
import { useSelector } from "react-redux";
import { moveOrderToTenant } from "shared/network/order.api";
import { useSnackbar } from "notistack";
import Loading from "components/Loading";
import { Order } from "shared/types";
import { ColorLens } from "@material-ui/icons";
import { COLORS } from "config/theme";
import { useHistory } from "react-router";

type Props = { order: Order };

const OrderTenantMove = ({ order }: Props) => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const user = useSelector((state: RootState) => state.authentication?.account?.user);
  const tenant = useSelector((state: RootState) => state.authentication?.selectedRelTenant?.tenant);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleTenantChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedTenant(event.target.value);
  };

  const handleMoveOrder = async () => {
    setLoading(true);
    if (selectedTenant) {
      try {
        await moveOrderToTenant(order?.id, Number(selectedTenant), tenant?.id);
        enqueueSnackbar("Megrendelés sikeresen áthelyezve!", { variant: "success" });
        setIsDialogOpen(false);
        history.push("/order/list");
      } catch (error: any) {
        if (error.data.status === "NOT_MODIFIABLE") {
          enqueueSnackbar("A megrendelés a státusza miatt nem módosítható!", { variant: "error" });
        } else {
          enqueueSnackbar("Hiba történt az áthelyezés során!", { variant: "error" });
        }
      }
    }
    setLoading(false);
  };

  return (
    <>
      {user.relUserTenants?.length > 1 && (
        <Button
          variant="outlined"
          style={{ height: 30, borderColor: COLORS.main, fontSize: 12, padding: 8 }}
          onClick={handleDialogOpen}
        >
          <FontAwesomeIcon
            icon={faSquareArrowUpRight}
            style={{ width: 16, height: 16, marginRight: 4 }}
          />
          Áthelyezés másik céghez
        </Button>
      )}
      <Dialog open={isDialogOpen} onClose={handleDialogClose} fullWidth maxWidth="xs">
        <DialogTitle>Válassz egy céget</DialogTitle>
        <DialogContent>
          <Loading open={loading} />
          <TextField
            select
            label="Tenant"
            value={selectedTenant || ""}
            onChange={handleTenantChange}
            fullWidth
          >
            {user.relUserTenants
              .filter(rel => rel.tenant?.id !== tenant?.id)
              .map(relTenant => (
                <MenuItem key={relTenant?.tenant?.id} value={relTenant?.tenant?.id}>
                  {relTenant?.tenant?.name}
                </MenuItem>
              ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={handleDialogClose} color="primary">
            Mégse
          </Button>
          <Button onClick={handleMoveOrder} color="primary" disabled={!selectedTenant}>
            Áthelyezés
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OrderTenantMove;
